"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    menuSplitGroupClassNames: function() {
        return menuSplitGroupClassNames;
    },
    useMenuSplitGroupStyles_unstable: function() {
        return useMenuSplitGroupStyles_unstable;
    }
});
const _react = require("@griffel/react");
const menuSplitGroupClassNames = {
    root: 'fui-MenuSplitGroup'
};
/**
 * Styles for the root slot
 */ const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        mc9l5x: "f22iagw",
        oe75ve: "f1mvlx34",
        Bu15iap: [
            "fsdyxoe",
            "fuk6rhi"
        ],
        B71tm0z: [
            "fn8z6db",
            "f1be8c1t"
        ],
        Gjs4sj: [
            "f1vtn0lh",
            "f8hq2kl"
        ],
        foni4y: "f7j48hl",
        Ie9k5m: "f13du8c1",
        f30fub: "fe64lw1",
        Jberyy: "f92oj5h"
    }
}, {
    d: [
        ".f22iagw{display:flex;}",
        ".f1mvlx34>.fui-MenuItem:nth-of-type(1){flex-grow:1;}",
        ".fsdyxoe>.fui-MenuItem:nth-of-type(2){border-top-left-radius:0;}",
        ".fuk6rhi>.fui-MenuItem:nth-of-type(2){border-top-right-radius:0;}",
        ".fn8z6db>.fui-MenuItem:nth-of-type(2){border-bottom-left-radius:0;}",
        ".f1be8c1t>.fui-MenuItem:nth-of-type(2){border-bottom-right-radius:0;}",
        ".f1vtn0lh>.fui-MenuItem:nth-of-type(2){padding-left:0;}",
        ".f8hq2kl>.fui-MenuItem:nth-of-type(2){padding-right:0;}",
        ".f7j48hl>.fui-MenuItem:nth-of-type(2)::before{content:\"\";}",
        ".f13du8c1>.fui-MenuItem:nth-of-type(2)::before{width:var(--strokeWidthThin);}",
        ".fe64lw1>.fui-MenuItem:nth-of-type(2)::before{height:20px;}",
        ".f92oj5h>.fui-MenuItem:nth-of-type(2)::before{background-color:var(--colorNeutralStroke1);}"
    ]
});
const useMenuSplitGroupStyles_unstable = (state)=>{
    'use no memo';
    const styles = useStyles();
    state.root.className = (0, _react.mergeClasses)(menuSplitGroupClassNames.root, styles.root, state.root.className);
    return state;
}; //# sourceMappingURL=useMenuSplitGroupStyles.styles.js.map
